import { HrpBaseClient } from './HrpBaseClient'

export class HrpBenefitPlanClient extends HrpBaseClient {
    constructor(
        hrpProxyApiUrl = process.env.HRP_PROXY_API_URL,
        hrpProxySecretName = process.env.HRP_PROXY_SECRET_NAME,
        axiosOptions
    ) {
        super(hrpProxyApiUrl, hrpProxySecretName, axiosOptions)
    }

    async getBenefitPlansByAccountKey({ accountKey }) {
        await this.createSecureAxiosInstance()

        if (!accountKey || isNaN(accountKey)) {
            throw new Error('Invalid account key, needs to be present and numeric');
        }

        const searchParams = {
            accountKey 
        }

        try {
            const response = await this.secureAxiosInstance.get(
                `/admin/api/benefitPlan/db/getBenefitPlansByAccountKey`, 
                {
                    params: searchParams
                }
            );

            return response.data
        } 
        catch (e) {
            throw e.response
        }
    }
}
